// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jEWU","rightAdornment":"Header_rightAdornment__cHT8n"};